import { render, staticRenderFns } from "./HoverView.vue?vue&type=template&id=87607964&scoped=true&"
import script from "./HoverView.vue?vue&type=script&lang=js&"
export * from "./HoverView.vue?vue&type=script&lang=js&"
import style0 from "./HoverView.vue?vue&type=style&index=0&id=87607964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87607964",
  null
  
)

export default component.exports